import { memo } from 'react';
import { connect } from 'react-redux';

import { TextareaField } from 'UIPackage/MainModule/components/TextareaField';
import { Row } from 'UIPackage/FormModule/components/Row';
import { FieldBlock } from 'UIPackage/FormModule/components/FieldBlock';
import { getKnmErknmPositionsSelectOptions } from 'KnmPackage/MainModule/selectors/knmSelectors';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';
import { SelectInputField } from 'UIPackage/MainModule/components/SelectInputField';
import { IDictionaryPositionSelectOption } from 'CorePackage/DictionariesModule/interfaces/IDictionaryPositionSelectOption';
import { IDictionaryParticipantPositionSelectOption } from 'CorePackage/DictionariesModule/interfaces/IDictionaryParticipantPositionSelectOption';
import { UploadFile } from 'UIPackage/MainModule/components/UploadFile';
import { useKnmDocumentAttachment } from 'KnmPackage/MainModule/hooks/useKnmDocumentAttachment';
import { IKnmFormAttachment } from 'KnmPackage/MainModule/interfaces/IKnmFormAttachment';

import styles from './PmOpCancel.module.scss';

interface IPmOpCancelProps {
  cancellationAttachment?: IKnmFormAttachment;
}

interface IPmOpCancelStoreProps {
  positionsSelectOptions: IDictionaryPositionSelectOption[] | IDictionaryParticipantPositionSelectOption[] | undefined;
}

const PmOpCancelWithoutStore = memo(
  ({ positionsSelectOptions, cancellationAttachment }: IPmOpCancelProps & IPmOpCancelStoreProps) => {
    const { downloadKnmDocumentAttachment } = useKnmDocumentAttachment();

    const downloadAttachment = () => {
      if (!cancellationAttachment) return null;

      const { fileName, fileSize } = cancellationAttachment;
      const filePath = cancellationAttachment.filePath || null;
      const mimeType = cancellationAttachment.mimeType || null;

      downloadKnmDocumentAttachment({ fileName, filePath, fileSize, mimeType });
    };

    return (
      <div className={`${styles.Wrapper}`}>
        <h2 className="shared-title__with-margin">Сведения об отмене предостережения</h2>

        <FieldBlock label={'Файл'} color="black" placementLabel="left" type="not-space" className={styles.FieldBlock}>
          <UploadFile
            fileName={cancellationAttachment?.fileName || ''}
            fileSize={cancellationAttachment?.fileSize || 0}
            onFileNameClick={downloadAttachment}
          />
        </FieldBlock>
        <FieldBlock label={'Комментарий'} placementLabel="left" color="black" className={styles.FieldBlock}>
          <TextareaField
            name={`cancellationComment`}
            disabled={true}
            autoHeight
            placeholder={'Информация об отмене результатов мероприятия'}
          />
        </FieldBlock>
        <div className={styles.NoteWarningFieldBlock}>
          <Row>
            <FieldBlock label="ФИО должностного лица" color="black" size="half">
              <TextareaField id="officialFullNameCancel" name="officialFullNameCancel" disabled={true} />
            </FieldBlock>
            <FieldBlock label="Должность лица, отменившего предостережение" color="black" size="half">
              <SelectInputField
                className={styles.PositionField}
                placeholder="Выберите должность"
                options={positionsSelectOptions}
                name={'warningContentPositionCancel'}
                disabled={true}
                isSearchable
                size="medium"
              />
            </FieldBlock>
          </Row>
        </div>
      </div>
    );
  },
);

const mapStateToProps = (state: IRootState): IPmOpCancelStoreProps => ({
  positionsSelectOptions: getKnmErknmPositionsSelectOptions(state),
});

export const PmOpCancel = connect(mapStateToProps)(PmOpCancelWithoutStore);
